/* eslint-disable max-lines */
import * as type from './DynamicFormsType';

export const initialState = {
    allForms: null,
    subjects: null,
    formStructure: null,
    formEntries: { entries: null, more: false },
    medias: null,
    entriesOfAForm: [],
    isDeletingFormEntry: false
};
export const dynamicFormsReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.GET_ALL_FORMS.SUCCESS:
            return {
                ...state,
                allForms: action.payload?.sort((a, b) => a.order - b.order)
            };
        case type.GET_FORM_STRUCTURE.SUCCESS:
            return { ...state, formStructure: action.payload };
        case type.CHANGE_VISIBLE_OF_FIELDS: {
            const { name, visible } = action.payload;
            const newList = state.formStructure?.fields?.map((val) => {
                if (val.name === name) {
                    return {
                        ...val,
                        presentation: {
                            ...val.presentation,
                            invisible: visible
                        }
                    };
                } else {
                    return val;
                }
            });
            return {
                ...state,
                formStructure: { ...state.formStructure, fields: newList }
            };
        }
        case type.ADD_NEW_FORM_STRUCTURE:
            return { ...state, allForms: [...state.allForms, action.payload] };
        case type.DELETE_FORM: {
            const formName = action.payload;
            const status = action.status;
            if (formName && status >= 200 && status < 400) {
                return {
                    ...state,
                    allForms: [...state.allForms.filter((form) => form.name !== formName)]
                };
            } else {
                return state;
            }
        }

        case type.ADD_NEW_FORM_ENTRY:
            return {
                ...state,
                formEntries: { entries: [action.payload, ...state.formEntries.entries] }
            };

        case type.UPDATE_FORM_ENTRY: {
            const newForm = action.payload;
            const newList = state.formEntries.entries.map((val) => {
                if (val.id === newForm?.id) {
                    return newForm;
                } else {
                    return val;
                }
            });
            return { ...state, formEntries: { entries: newList } };
        }
        case type.IS_DELETING_FORM_ENTRY:
            return { ...state, isDeletingFormEntry: action.payload };
        case type.REMOVE_FORM_ENTRY: {
            const newList = state.formEntries.entries.filter((val) => val.id !== action.payload);
            return { ...state, formEntries: { entries: newList } };
        }
        case type.SET_ENTRIES_OF_A_FORM.SUCCESS:
            return { ...state, entriesOfAForm: action.payload };
        case type.GET_SUBJECTS:
            return { ...state, subjects: action.payload };
        case type.PENDING__MORE_ENTRIES:
            return {
                ...state,
                formEntries: { ...state.formEntries, more: action.payload }
            };
        case type.GET_FORM_REPORT: {
            const formName = action.payload.name;
            const existItem = state.allForms?.find((item) => item.name === formName);
            if (existItem) {
                return {
                    ...state,
                    allForms: state.allForms.map((item) =>
                        item.name === existItem.name ? { ...item, export_status: 'G' } : item
                    )
                };
            } else {
                return state;
            }
        }
        case type.DELETE_FORM_EXPORT: {
            const formName = action.payload;
            const deleteFormExport = state.allForms.map((item) =>
                item.name === formName ? { ...item, export_status: 'E', export_file: null } : item
            );
            return { ...state, allForms: deleteFormExport };
        }
        case type.GET_FORM_ENTRIES.SUCCESS:
            if (action.params?.offset === 0) {
                return {
                    ...state,
                    formEntries: {
                        entries: action.payload,
                        more: action.payload && action.payload.length === 0 ? 'ALL' : false
                    }
                };
            } else if (state.formEntries && state.formEntries.entries) {
                return {
                    ...state,
                    formEntries: {
                        entries: [...state.formEntries.entries, ...action.payload],
                        more:
                            action.payload &&
                            (action.payload.length === 0 ||
                                action.payload.length < action.params?.limit)
                                ? 'ALL'
                                : false
                    }
                };
            } else {
                return {
                    ...state,

                    formEntries: {
                        entries: action.payload,
                        more:
                            action.payload &&
                            (action.payload.length === 0 ||
                                action.payload.length < action.params?.limit)
                                ? 'ALL'
                                : false
                    }
                };
            }
        case type.EDIT_FORM:
            return {
                ...state,
                allForms: state.allForms.map((item) =>
                    item.name === action.payload.name ? action.payload : item
                )
            };
        case type.SORT_FORMS: {
            const forms = action.payload;
            return {
                ...state,
                allForms: forms
            };
        }
        case type.REORDER_FORM: {
            const { name, order } = action.payload;
            const existItem = state.allForms.find((item) => item.name === name);
            const result = state.allForms.map((item) =>
                item.name === existItem.name ? { ...item, order: order } : item
            );
            return {
                ...state,
                allForms: result
            };
        }
        case type.REORDER_FORM_FAILURE: {
            const data = action.payload;
            return {
                ...state,
                allForms: data
            };
        }
        case type.UPLOAD_MEDIA_SUCCESS: {
            const { formName, url, fieldName } = action.payload;
            const newFile = {
                [fieldName]: {
                    uploadedLink: url,
                    status: 'success'
                }
            };
            if (state.medias?.[formName]) {
                return {
                    ...state,
                    medias: {
                        ...state.medias,
                        [formName]: {
                            ...state.medias?.[formName],
                            ...newFile
                        }
                    }
                };
            } else {
                return {
                    ...state,
                    medias: {
                        ...state.medias,
                        [formName]: {
                            ...newFile
                        }
                    }
                };
            }
        }
        case type.UPLOAD_MEDIA_REQUEST: {
            const { formName, fieldName } = action.payload;
            const newFile = {
                [fieldName]: {
                    uploadedLink: state.medias?.[formName]?.uploadedLink,
                    status: 'uploading'
                }
            };
            if (state.medias?.[formName]) {
                return {
                    ...state,
                    medias: {
                        ...state.medias,
                        [formName]: {
                            ...state.medias?.[formName],
                            ...newFile
                        }
                    }
                };
            } else {
                return {
                    ...state,
                    medias: {
                        ...state.medias,
                        [formName]: {
                            ...newFile
                        }
                    }
                };
            }
        }
        case type.UPLOAD_MEDIA_ERROR: {
            const { formName, fieldName } = action.payload;
            const newFile = {
                [fieldName]: {
                    uploadedLink: null,
                    status: 'error'
                }
            };
            if (state.medias?.[formName]) {
                return {
                    ...state,
                    medias: {
                        ...state.medias,
                        [formName]: {
                            ...state.medias?.[formName],
                            ...newFile
                        }
                    }
                };
            } else {
                return {
                    ...state,
                    medias: {
                        ...state.medias,
                        [formName]: {
                            ...newFile
                        }
                    }
                };
            }
        }
        default:
            return state;
    }
};
